<!-- 采购退补 -->
<template>
  <div class='page_content'>
    <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <purInitiaRefundAction v-if="showStatus" ref="purchaseRefundAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></purInitiaRefundAction>
    </el-drawer>
    <subComponents ref="showSelectData"></subComponents>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
          <template slot="searchInput" slot-scope="{formOneValue}">
            <!-- 业务员	 -->
            <el-select filterable v-if="formOneValue.entityField == 'woamSalesman'" v-model="getRequestData[formOneValue.entityField]">
              <el-option label="全部" value="">
              </el-option>
              <el-option v-for="(values, keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
              </el-option>
            </el-select>
          </template>
        </vSearch>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" size="mini" stripe :data="returnData.list" :height="tableHeight" border style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row>
        <el-table-column type="selection" width="40">
        </el-table-column>
        <template v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable">
          <el-table-column align="center" v-if="tableValye.isShow==1" :key="tableKey" :prop="tableValye.entityField" show-overflow-tooltip :min-width="tableValye.fieldWeight" :label="tableValye.showField">
            <template slot-scope="scope">
              <!-- <span v-if="tableValye.fieldType == 'date'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                </span>
              </span> -->
              <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                            {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                        </span>
              <span v-else-if="tableValye.entityField == 'createTime'">
                <span v-if="scope.row[tableValye.entityField]">
                  {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                </span>
              </span>
              <span v-else-if="tableValye.isRift == 1">
                <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
              </span>
              <el-tag v-else-if="tableValye.entityField == 'rrmState'" size="mini">
                {{JSON.parse(tableValye.formatterContent)[scope.row[tableValye.entityField]].value}}
              </el-tag>
              <span v-else>
                {{scope.row[tableValye.entityField]}}
              </span>
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import purInitiaRefundAction from '@/components/purInitiaRefundAction.vue'
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { SearchScheme,purInitiaRefundAction },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      seTitle: "",
      DialogVisible: false,
      seWidth: "",
      seId: "",
      fil: "",
      getRequestData: {
        rrmRapcus: "", // 供应商
        rrmRapcusName: "", // 供应商名称
        smId: "",
        smName: "",
        opmId: "",
        opmName: "",
        page: 1,
        rows: 30,
        start:
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],

      pageShowData: [],
      formDataList: [],
      showStatus: false,
      actionData: [],
      parentSearchData: {},
      multipleSelection: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    "getRequestData.rrmRapcusName": {
      handler: function (newValue, oldValue) {
        if (newValue == "") {
          this.getRequestData.rrmRapcus = "";
        }
      },
      deep: true,
    },
  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    // 子组件触发
    drawerCancel() {
      this.showStatus = false;
      this.getDataList();
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true;
      this.seId = sId;
      this.sField = sField;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    // 赋值字段
    paramValue(val) {
      console.log(this.sField);
      let arr = this.sField.split(",");
      arr.forEach((item) => {
        this.getRequestData[item] = val[item];
      });
    },
    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true;
        // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId);
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: { isPenetrate }, //参数
          },
          "*"
        );
      }
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val);
      }
    },
    getSeWidth(e) {
      this.seWidth = e + "%";
    },
    getSearchName(e) {
      this.seTitle = e;
    },
    isShowData(name, value) {
      console.log(name);
      switch (name) {
        case "rrmRapcus":
          var dataInfo = sessionStorage.getItem("selectSupplierData");
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo);
            this.getRequestData.rrmRapcus = dataInfo.smId;
            this.getRequestData.rrmRapcusName = dataInfo.smName;
          }
          break;
        default:
          this.sendDataInfo[name] = value;
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({ ids: [pathId.jurId] });
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    clear(val) {
      if (val) {
        var arr = val.split(",")
        arr.forEach(item => {
          this.$set(this.getRequestData, item, "")
        })
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showStatus = true;
          this.actionData = {
            cate: 0,
            formData: this.formDataList,
            oldData: "",
            orderId: "",
            printSouce: "",
            printJurId: "",
          };
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
          if (this.multipleSelection.length != 1) {
            this.$message({
              message: "请先选中一条操作数据",
              type: "error",
            });
            return false;
          }
          this.showStatus = true;
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: this.multipleSelection[0],
            orderId: this.multipleSelection[0].rrmId,
            printSouce: "",
            printJurId: "",
          };
          break;
        case 2:
          this.delDataAction();
          break;
        case 3:
          this.submitDataAction();
          break;
        case 8:
          this.showPrintPlan();
          break;
      }
    },

    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    showPrintPlan() {
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请先选中一条操作数据",
          type: "error",
        });
        return false;
      }
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        var info = this.multipleSelection[0];
        this.$refs.printPlan.openDia(info.rrmId);
      } else {
        return;
      }
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      if (this.getRequestData.smName == "") {
        this.getRequestData.smId = "";
      }
      if (this.getRequestData.opmName == "") {
        this.getRequestData.opmId = "";
      }
      let responseData = await this.$http.getPurchaseInitList(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 提交审核
    async submitDataAction() {
      if (this.returnData.list.length <= 0) {
        this.$message({
          message: "暂无数据",
          type: "error",
        });
        return false;

      }
      var dataInfo = []
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先选中要操作数据",
          type: "error",
        });
        return false;
      }
      this.multipleSelection.forEach(item => {
        dataInfo.push(item.rrmId)
      })
      // this.$confirm("确定要提交审核吗？", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(async () => {
      var delData = {
        ids: dataInfo,
      };
      let responseData = await this.$http.submitPurchaseReimbursement(
        delData
      );
      if (responseData.status == 200) {
        this.$message({
          type: "success",
          message: "操作成功!",
        });

        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
      // })
      // .catch(() => { });
    },

    // 删除数据
    delDataAction() {
      if (this.returnData.list.length <= 0) {
        this.$message({
          message: "暂无数据",
          type: "error",
        });
        return false;
      }
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请先选中一条操作数据",
          type: "error",
        });
        return false;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [this.multipleSelection[0].rrmId],
          };
          let responseData = await this.$http.delPurchaseInitment(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });

            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => { });
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}

.el-input-group__append .el-button {
  margin: -18px -28px !important;
}
</style>